module.exports = __webpack_public_path__ + "media/images/icons/twotone/folder-1436c99f168393281da52c1f339d9146.svg";